/**
 * Loading Spinner Component
 * Shows during API calls
 */

import React from 'react';
import styled from 'styled-components';

const SpinnerOverlay = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: ${({ $isVisible }) => ($isVisible ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
`;

const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
`;

const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 4px solid ${({ theme }) => theme.primary}33;
  border-top: 4px solid ${({ theme }) => theme.primary};
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const LoadingText = styled.p`
  color: ${({ theme }) => theme.text};
  font-size: 1.1rem;
  font-weight: 500;
  margin: 0;
`;

interface LoaderProps {
  isVisible: boolean;
  message?: string;
}

const Loader: React.FC<LoaderProps> = ({ isVisible, message = 'Sending your message...' }) => {
  return (
    <SpinnerOverlay $isVisible={isVisible}>
      <SpinnerContainer>
        <Spinner />
        <LoadingText>{message}</LoadingText>
      </SpinnerContainer>
    </SpinnerOverlay>
  );
};

export default Loader;
